export default {

    setPostPriorityLevels(state, postPriorityLevels) {
        state.priorityLevels = postPriorityLevels;
    },
}